// Components/User/MiniCRM/RespondDeal.jsx
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Handler";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";
import "../../../Assets/css/style.css";

const RespondDeal = () => {
  const navigate       = useNavigate();
  const { id: dealId } = useParams();
  const [loading, setLoading] = useState(null); // "ACCEPTED" | "REJECTED" | null

  const respond = async (status) => {
    setLoading(status);
    try {
      const res = await Handler({
        method: "POST",
        url:    "/mini_crm/respond.php",
        data:   { deal_id: parseInt(dealId), status },
      });
      if (res.success) {
        toast.success(
          status === "ACCEPTED" ? "Deal accepted!" : "Deal rejected."
        );
        navigate("/user/crm");
      } else {
        toast.error(res.message || "Failed to respond");
      }
    } catch {
      toast.error("Something went wrong.");
    } finally {
      setLoading(null);
    }
  };

  return (
    <MainLayout>
      <FeedLayout>
        <div className="crm-page">

          <div className="crm-header">
            <div>
              <h1 className="crm-title">Respond to Deal</h1>
              <p className="crm-subtitle">Deal #{dealId} — Accept or reject this request</p>
            </div>
            <button
              className="crm-btn crm-btn--outline"
              onClick={() => navigate("/user/crm")}
            >
              <i className="bx bx-arrow-back" /> Back
            </button>
          </div>

          <div className="crm-form-card crm-respond-card">
            <div className="crm-respond-icon">
              <i className="bx bx-check-shield" />
            </div>
            <h3 className="crm-respond-title">You have a pending deal request</h3>
            <p className="crm-respond-desc">
              Review the deal and choose to accept or reject it. Accepting will
              allow both parties to chat and negotiate further.
            </p>

            <div className="crm-respond-actions">
              <button
                className="crm-btn crm-btn--reject"
                onClick={() => respond("REJECTED")}
                disabled={!!loading}
              >
                {loading === "REJECTED" ? (
                  <><span className="crm-btn-spinner" /> Rejecting…</>
                ) : (
                  <><i className="bx bx-x-circle" /> Reject Deal</>
                )}
              </button>
              <button
                className="crm-btn crm-btn--accept"
                onClick={() => respond("ACCEPTED")}
                disabled={!!loading}
              >
                {loading === "ACCEPTED" ? (
                  <><span className="crm-btn-spinner" /> Accepting…</>
                ) : (
                  <><i className="bx bx-check-circle" /> Accept Deal</>
                )}
              </button>
            </div>
          </div>

        </div>
      </FeedLayout>
    </MainLayout>
  );
};

export default RespondDeal;